<template>
    <div id="sidebar" class="h-screen p-5 flex flex-col justify-between">
      <div class="flex flex-col sidebar-content">
        <!-- ANCHOR LOGO -->
        <router-link to="/" title="Retourner à l'accueil" class="w-2/3 my-5 mx-auto">
          <img :src="logo" alt="CodeSnippet" class="w-full m-auto" />
        </router-link>
        <nav class="flex-1">

          <router-link :to="{ name: 'Create Project' }" title="Créer un nouveau projet" class="mb-5 flex justify-center">
            <Button
              label="Nouveau projet"
              class="p-button-rounded p-button-outline small-btn w-full"
            />
          </router-link>

          <router-link
            :to="{ name: 'Dashboard' }"
            title="Accéder à mes projets"
          >
            <div class="nav-link">
              <Button
                class="p-button-link text-left"
                label="Mes projets"
                icon="mdi-view-dashboard"
                :icon-size="30"
              />
            </div>
          </router-link>
          <router-link
            :to="{ name: 'Account' }"
            title="Accéder à mon compte"
          >
            <div class="nav-link">
              <Button
                class="p-button-link text-left"
                label="Mon compte"
                icon="mdi-account-box"
                :icon-size="30"
              />
            </div>
          </router-link>
          <p class="mt-5 pl-1 text-divider" v-if='projects.length'>Projets récents</p>
          <router-link :to="getProjectLink(project)" :title="[`Accéder au projet ${project.title}`]"
            v-for="project in projects"
            :key="project.id"
          >
            <div class="nav-link recent-project">
              <Button
                class="p-button-link text-left"
                :label="project.title"
                icon="mdi-folder-outline"
                :icon-size="30"
              />
            </div>
          </router-link>
        </nav>
      </div>
      <div class="flex flex-col items-center justify-center mt-3">

        <div class="flex mt-5">
          <!-- Déconnexion -->
            <Button
              @click="logout()"
              class="p-button-rounded small-btn mr-3"
              icon="mdi-power"
              v-tooltip="{ content: 'Déconnexion', placement: 'right' }"
              :icon-size="20"
            />

          <!-- Dark Mode -->
          <Button
            class="p-button-rounded small-btn"
            @click="darkMode"
            v-tooltip="{ content: themeTooltip, placement: 'right' }"
            :icon="this.$store.state.dark ? 'mdi-white-balance-sunny' : 'mdi-moon-waning-crescent'"
            :icon-size="20"
          />
        </div>

        <div class="flex mt-3">
          <!-- Links -->
          <router-link class="link" :to="{ name: 'Guide' }">
            <span>Guide</span>
          </router-link>
          &nbsp;-&nbsp;
          <router-link class="link" :to="{ name: 'CGU' }">
            <span>CGU</span>
          </router-link>
        </div>
        <div class="mt-2 flex flex-col items-center">
          <span>© {{ new Date().getFullYear() }} - CodeSnippet</span>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import logo from "~/assets/logo.png";

export default {
  name: "SideBar",
  data: () => ({
    logo: logo,
  }),
  mounted() {
  this.fetchRecents()
  },
  computed: {
    ...mapGetters({
      projects: 'projects/getRecents'
    }),
    themeTooltip() {
      if( this.$store.state.dark ) return 'Activer le thème clair';
      else return 'Activer le thème sombre';
    }
  },
  methods: {
    ...mapActions({
      fetchRecents: "projects/fetchRecents",
      logoutStore: 'auth/logout',
    }),
    getProjectLink(project) {
      if (project.groups.length === 1) {
        const uniqueGroupId = project.groups[0].id
        return `/projects/${project.id}/groups/${uniqueGroupId}`
      } else {
        const modelGroupId = project.groups.find(group => group.is_model).id
        return `/projects/${project.id}/groups/${modelGroupId}`
      }
    },
    logout() {
      this.logoutStore().then(() => {
        this.$router.push({ name: 'Accueil' });
      });
    },
    darkMode() {
      const currentTheme = !this.$store.state.dark;

      this.$store.commit('changeState', {
        key: 'dark',
        data: currentTheme,
      });
      this.$dark(currentTheme);
    },
  },
};
</script>
